import {
  FiUsers,
  FiCreditCard,
  FiFileText,
  FiGift,
  FiDollarSign,
  FiLayers,
  FiClipboard,
  FiActivity,
  FiBarChart2,
  FiMail,
  FiShield,
} from 'react-icons/fi';

/** Icon map for workflow steps loaded from API (key → react-icon component). */
export const WORKFLOW_ICON_MAP = {
  customers: FiUsers,
  plans: FiCreditCard,
  contracts: FiFileText,
  offers: FiGift,
  payment: FiDollarSign,
  subscriptions: FiLayers,
  invoices: FiClipboard,
  usage: FiActivity,
  reports: FiBarChart2,
  notifications: FiMail,
  audit: FiShield,
};

export function mapApiStepToWorkflowStep(apiDoc) {
  const meta = apiDoc.content?.workflowMeta || {};
  const key = meta.key || apiDoc.slug;
  return {
    id: meta.id ?? apiDoc.order,
    key,
    title: apiDoc.title.replace(/^Step \d+ — /, ''),
    description: apiDoc.summary,
    subtitle: apiDoc.summary,
    path: meta.path,
    permission: meta.permission,
    icon: WORKFLOW_ICON_MAP[key] || FiFileText,
    accent: meta.accent || '#6366f1',
    externalCreatePath: meta.externalCreatePath,
    slug: apiDoc.slug,
    algorithmSteps: apiDoc.content?.steps,
  };
}

export default WORKFLOW_ICON_MAP;
